export default "__VITE_ASSET__CqaO$MAg__"